module.exports = __webpack_public_path__ + "static/media/swap-space.3db0eb2d.svg";